<patron-context-menu [target]="target" [menuItems]="menuItems"></patron-context-menu>
